

import { Component, Prop } from 'vue-property-decorator'
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TooltipItem,
} from 'chart.js'

import Base from "../../../core/components/Base.vue";
import { getMonthsArray } from '../../tools/booking.stats.tools';
import { SlotStats } from '../../model/statistics/SlotStats';


ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement)


@Component({
  components: { LineChartGenerator }
})
export default class LineChartNoShowRatio extends Base {


  get statistics() {
    return this.$store.state.booking.bookingStatistics;
  }

  @Prop({ default: 'line-chart-NoShow-ratio-evolution' }) chartId!: string

  @Prop({ default: 'label' }) datasetIdKey!: string

  @Prop({ default: 50 }) width!: number

  @Prop({ default: 25 }) height!: number

  @Prop({ default: 'full-size' }) cssClasses!: string

  @Prop() styles!: unknown

  @Prop() plugins!: unknown[]

  @Prop() chartOptions!: unknown[]

  barChartConfig = {
    labels: getMonthsArray(),
    datasets: [
      {
        type: 'line',
        label: 'pourcentage de noShow / mois',
        data:
          this.getMonthsNoShowRatio(Object.values(this.statistics.monthly)),
        backgroundColor: [
          'rgba(220, 53, 69, 0.7)',
        ],
        fill: false,
        pointBorderWidth: 0,
        pointStyle: 'rectRot',
        pointRadius: 4, 
        segment: {
          borderColor: (ctx: {
            p0: { parsed: { y: number } },
            p1: { parsed: { y: number } }
          }): string => {
            const y0 = ctx.p0.parsed.y
            const y1 = ctx.p1.parsed.y

            if (y1 > y0) return 'red'
            if (y1 < y0) return 'green'
            return 'gray'
          },
        },
        borderWidth: 3,
      }
    ]
  }

  options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<'line'>) => {
            const label = context.dataset.label || '';
            const value = context.parsed.y.toFixed(1);
            return `${label}: ${value}%`;
          }
        },
        titleFont: {
          size: 18
        },
        bodyFont: {
          size: 16
        },
        footerFont: {
          size: 14
        },
        boxPadding: 10,
        padding: 12,
      },
      legend: { 
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          font: {
            size: 16
          },
        }
       },
    },
    scales: {
      y: {
        min: 0,
        ticks: {
          display: true,
          stepSize: 20,
        },
        grid: {
          drawOnChartArea: false,
          drawTicks: true
        },
        scaleLabel: { display: false },
        title: {
          display: true,
          text: '% No Shows',
          font: {
            size: 11
          }
        }
      },
      x: {
        ticks: {
          font: {
            size:11
          }
        }
      }
    }
  }

  getMonthDataReduced(monthData: SlotStats[], statReq: string) {
    return monthData.reduce((sum: number, currentMonth: SlotStats) => {
      return sum + currentMonth[statReq]
    }, 0)
  }

  getMonthsNoShowRatio(monthsData: SlotStats[][]) {
    const array: number[] = [];

    monthsData.forEach((monthData: SlotStats[]) => {
      array.push((this.getMonthDataReduced(monthData, 'validBooking') - this.getMonthDataReduced(monthData, 'completedBooking')) / this.getMonthDataReduced(monthData, 'validBooking') * 100)
    })

    return array.reverse()
  }
}

